import React from 'react';
import ReactDOM from 'react-dom/client';
import './custom.scss';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import axios from 'axios';

import 'bootstrap/dist/js/bootstrap.bundle';
import 'bootstrap-icons/font/bootstrap-icons.css';

// base url APIS
// const baseUrl = document.getElementById("baseUrl").value;
const baseUrl = process.env.REACT_APP_BASE_URL;

axios.defaults.baseURL = `${baseUrl}api`;
// axios.defaults.baseURL = `${"http://192.168.121.155:8082/"}api`;

document.addEventListener('dragstart', function (event) {
  event.preventDefault();
});

document.addEventListener('drop', function (event) {
  event.preventDefault();
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
